module.exports = [{
      plugin: require('D:/Jenkins Workspaces/Prod/Audience/Lauder Research Module/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
